import { i18n } from '@/i18n';
import { DialogListConfig, ModuleListConfig, ModuleName } from '@/types/module-type';
import TravelAssistant from '@/components/area/macao/travel-assistant.vue';
import HotMerchant from '@/components/hot-merchant.vue';
import AreaREcommend from '@/components/area-recommend.vue';

// 中国澳门模块配置
export const MACAO_MODULE_CONF: ModuleListConfig = [
  {
    moduleName: ModuleName.TravelAssistant,
    component: TravelAssistant,
    sort: 2,
    moduleTitle: '',
    extraConfig: {
      modulePositionId: ['1100040000370010'],
    },
  },
  {
    moduleName: ModuleName.HotMerchant,
    component: HotMerchant,
    sort: 3,
    moduleTitle: i18n('推薦商戶'),
  },
  {
    moduleName: ModuleName.AreaREcommend,
    component: AreaREcommend,
    sort: 4,
    moduleTitle: i18n('探尋更多目的地'),
  },
];

// 中国澳门弹窗配置
export const MACAO_DIALOG_CONF: DialogListConfig = [];
